//@flow

import React, { Component } from 'react';
import capitalize from 'lodash/capitalize';

import makeUrl from '../../lib/makeUrl';
import AddBtnMobile from './Common/AddBtnMobile';
import type { LodgeData } from './../../types/cards';
import { HGCardBase, RatingAndPrice, CardBodyBottom, CardBodyTop } from './Common';

type Props = {
  handleCardClick: Function,
  editable: Object,
  cardData: LodgeData,
  url: string,
};

export default class LodgeCard extends Component<Props> {
  render() {
    const { editable, cardData, url } = this.props;
    const { address, name, starting_price, id, average_rating, reviews } = cardData;
    const lodgeDetailUrl = makeUrl.goToLodgeDetails(name, id, address);

    return (
      <HGCardBase
        className="lodgeCard"
        editable={editable}
        cardData={cardData}
        url={url || lodgeDetailUrl}
      >
        <CardBodyTop title={name} type="lodge" url={url || lodgeDetailUrl}>
          <div className="location">
            <p>{address && capitalize(address)}</p>
          </div>
          <AddBtnMobile editable={editable} cardData={cardData} />
        </CardBodyTop>

        <CardBodyBottom>
          <RatingAndPrice
            price={starting_price}
            average_rating={average_rating}
            reviews={reviews}
          />
        </CardBodyBottom>
      </HGCardBase>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cards/LodgeCard.jsx